export const countryList = [
  { cn: '阿尔巴尼亚', code: '355', en: 'Albania', pinyin: 'aerbaniya' },
  { cn: '阿尔及利亚', code: '213', en: 'Algeria', pinyin: 'aerjiliya' },
  { cn: '阿富汗', code: '93', en: 'Afghanistan', pinyin: 'afuhan' },
  { cn: '阿根廷', code: '54', en: 'Argentina', pinyin: 'agenting' },
  { cn: '阿拉伯联合酋长国', code: '971', en: 'United Arab Emirates', pinyin: 'alabolianheqiuchangguo' },
  { cn: '阿鲁巴', code: '297', en: 'Aruba', pinyin: 'aluba' },
  { cn: '阿曼', code: '968', en: 'Oman', pinyin: 'aman' },
  { cn: '阿塞拜疆', code: '994', en: 'Azerbaijan', pinyin: 'asaibaijiang' },
  { cn: '埃及', code: '20', en: 'Egypt', pinyin: 'aiji' },
  { cn: '埃塞俄比亚', code: '251', en: 'Ethiopia', pinyin: 'aisaiebiya' },
  { cn: '爱尔兰', code: '353', en: 'Ireland', pinyin: 'aierlan' },
  { cn: '爱沙尼亚', code: '372', en: 'Estonia', pinyin: 'aishaniya' },
  { cn: '安道尔', code: '376', en: 'Andorra', pinyin: 'andaoer' },
  { cn: '安哥拉', code: '244', en: 'Angola', pinyin: 'angela' },
  { cn: '安圭拉', code: '1264', en: 'Anguilla', pinyin: 'anguila' },
  { cn: '安提瓜和巴布达', code: '1268', en: 'Antigua and Barbuda', pinyin: 'antiguahebabuda' },
  { cn: '奥地利', code: '43', en: 'Austria', pinyin: 'aodili' },
  { cn: '澳大利亚', code: '61', en: 'Australia', pinyin: 'aodaliya' },
  { cn: '巴巴多斯', code: '1246', en: 'Barbados', pinyin: 'babaduosi' },
  { cn: '巴布亚新几内亚', code: '675', en: 'Papua New Guinea', pinyin: 'babuyaxinjineiya' },
  { cn: '巴哈马', code: '1242', en: 'Bahamas', pinyin: 'bahama' },
  { cn: '巴基斯坦', code: '92', en: 'Pakistan', pinyin: 'bajisitan' },
  { cn: '巴拉圭', code: '595', en: 'Paraguay', pinyin: 'balagui' },
  { cn: '巴勒斯坦', code: '970', en: 'Palestine', pinyin: 'balesitan' },
  { cn: '巴林', code: '973', en: 'Bahrain', pinyin: 'balin' },
  { cn: '巴拿马', code: '507', en: 'Panama', pinyin: 'banama' },
  { cn: '巴西', code: '55', en: 'Brazil', pinyin: 'baxi' },
  { cn: '白俄罗斯', code: '375', en: 'Belarus', pinyin: 'baieluosi' },
  { cn: '百慕大', code: '1441', en: 'Bermuda', pinyin: 'baimuda' },
  { cn: '保加利亚', code: '359', en: 'Bulgaria', pinyin: 'baojialiya' },
  { cn: '贝宁', code: '229', en: 'Benin', pinyin: 'beining' },
  { cn: '比利时', code: '32', en: 'Belgium', pinyin: 'bilishi' },
  { cn: '冰岛', code: '354', en: 'Iceland', pinyin: 'bingdao' },
  { cn: '波多黎各', code: '1', en: 'Puerto Rico', pinyin: 'boduolige' },
  { cn: '波兰', code: '48', en: 'Poland', pinyin: 'bolan' },
  { cn: '玻利维亚', code: '591', en: 'Bolivia', pinyin: 'boliweiya' },
  { cn: '伯利兹', code: '501', en: 'Belize', pinyin: 'bolizi' },
  { cn: '博茨瓦纳', code: '267', en: 'Botswana', pinyin: 'bociwana' },
  { cn: '不丹', code: '975', en: 'Bhutan', pinyin: 'budan' },
  { cn: '布基纳法索', code: '226', en: 'Burkina Faso', pinyin: 'bujinafasuo' },
  { cn: '布隆迪', code: '257', en: 'Burundi', pinyin: 'bulongdi' },
  { cn: '朝鲜', code: '850', en: 'North Korea', pinyin: 'chaoxian' },
  { cn: '丹麦', code: '45', en: 'Denmark', pinyin: 'danmai' },
  { cn: '德国', code: '49', en: 'Germany', pinyin: 'deguo' },
  { cn: '东帝汶', code: '670', en: 'Timor-Leste', pinyin: 'dongdiwen' },
  { cn: '多哥', code: '228', en: 'Togo', pinyin: 'duoge' },
  { cn: '多米尼加', code: '1809', en: 'Dominican Republic', pinyin: 'duominijia' },
  { cn: '多米尼克', code: '1767', en: 'Dominica', pinyin: 'duominike' },
  { cn: '俄罗斯', code: '7', en: 'Russia', pinyin: 'eluosi' },
  { cn: '厄瓜多尔', code: '593', en: 'Ecuador', pinyin: 'eguaduoer' },
  { cn: '厄立特里亚', code: '291', en: 'Eritrea', pinyin: 'eliteliya' },
  { cn: '法国', code: '33', en: 'France', pinyin: 'faguo' },
  { cn: '法罗群岛', code: '298', en: 'Faroe Islands', pinyin: 'faluoqundao' },
  { cn: '法属波利尼西亚', code: '689', en: 'French Polynesia', pinyin: 'fashubolinixiya' },
  { cn: '法属圭亚那', code: '594', en: 'French Guiana', pinyin: 'fashuguiyana' },
  { cn: '法属圣马丁', code: '590', en: 'Saint Martin', pinyin: 'fashushengmading' },
  { cn: '梵蒂冈', code: '39', en: 'Vatican', pinyin: 'fandigang' },
  { cn: '菲律宾', code: '63', en: 'Philippines', pinyin: 'feilvbin' },
  { cn: '斐济', code: '679', en: 'Fiji', pinyin: 'feiji' },
  { cn: '芬兰', code: '358', en: 'Finland', pinyin: 'fenlan' },
  { cn: '佛得角', code: '238', en: 'Cape Verde', pinyin: 'fodejiao' },
  { cn: '福克兰群岛', code: '500', en: 'Falkland Islands', pinyin: 'fukelanqundao' },
  { cn: '冈比亚', code: '220', en: 'Gambia', pinyin: 'gangbiya' },
  { cn: '刚果（布）', code: '242', en: 'Congo - Brazzaville', pinyin: 'gangguo(bu)' },
  { cn: '刚果（金）', code: '243', en: 'Congo - Kinshasa', pinyin: 'gangguo(jin)' },
  { cn: '哥伦比亚', code: '57', en: 'Colombia', pinyin: 'gelunbiya' },
  { cn: '哥斯达黎加', code: '506', en: 'Costa Rica', pinyin: 'gesidalijia' },
  { cn: '格林纳达', code: '1473', en: 'Grenada', pinyin: 'gelinnada' },
  { cn: '格陵兰', code: '299', en: 'Greenland', pinyin: 'gelinglan' },
  { cn: '格鲁吉亚', code: '995', en: 'Georgia', pinyin: 'gelujiya' },
  { cn: '古巴', code: '53', en: 'Cuba', pinyin: 'guba' },
  { cn: '瓜德罗普', code: '590', en: 'Guadeloupe', pinyin: 'guadeluopu' },
  { cn: '关岛', code: '1671', en: 'Guam', pinyin: 'guandao' },
  { cn: '圭亚那', code: '592', en: 'Guyana', pinyin: 'guiyana' },
  { cn: '哈萨克斯坦', code: '7', en: 'Kazakhstan', pinyin: 'hasakesitan' },
  { cn: '海地', code: '509', en: 'Haiti', pinyin: 'haidi' },
  { cn: '韩国', code: '82', en: 'South Korea', pinyin: 'hanguo' },
  { cn: '荷兰', code: '31', en: 'Netherlands', pinyin: 'helan' },
  { cn: '荷属安的列斯', code: '599', en: 'Netherlands Antilles', pinyin: 'heshuandeliesi' },
  { cn: '洪都拉斯', code: '504', en: 'Honduras', pinyin: 'hongdulasi' },
  { cn: '基里巴斯', code: '686', en: 'Kiribati', pinyin: 'jilibasi' },
  { cn: '吉布提', code: '253', en: 'Djibouti', pinyin: 'jibuti' },
  { cn: '吉尔吉斯斯坦', code: '996', en: 'Kyrgyzstan', pinyin: 'jierjisisitan' },
  { cn: '几内亚', code: '224', en: 'Guinea', pinyin: 'jineiya' },
  { cn: '几内亚比绍', code: '245', en: 'Guinea-Bissau', pinyin: 'jineiyabishao' },
  { cn: '加拿大', code: '1', en: 'Canada', pinyin: 'jianada' },
  { cn: '加纳', code: '233', en: 'Ghana', pinyin: 'jiana' },
  { cn: '加蓬', code: '241', en: 'Gabon', pinyin: 'jiapeng' },
  { cn: '柬埔寨', code: '855', en: 'Cambodia', pinyin: 'jianbuzhai' },
  { cn: '捷克', code: '420', en: 'Czech Republic', pinyin: 'jieke' },
  { cn: '津巴布韦', code: '263', en: 'Zimbabwe', pinyin: 'jinbabuwei' },
  { cn: '喀麦隆', code: '237', en: 'Cameroon', pinyin: 'kamailong' },
  { cn: '卡塔尔', code: '974', en: 'Qatar', pinyin: 'kataer' },
  { cn: '开曼群岛', code: '1345', en: 'Cayman Islands', pinyin: 'kaimanqundao' },
  { cn: '科科斯群岛', code: '61', en: 'Cocos Islands', pinyin: 'kekesiqundao' },
  { cn: '科摩罗', code: '269', en: 'Comoros', pinyin: 'kemoluo' },
  { cn: '科特迪瓦', code: '225', en: 'Côte d’Ivoire', pinyin: 'ketediwa' },
  { cn: '科威特', code: '965', en: 'Kuwait', pinyin: 'keweite' },
  { cn: '克罗地亚', code: '385', en: 'Croatia', pinyin: 'keluodiya' },
  { cn: '肯尼亚', code: '254', en: 'Kenya', pinyin: 'kenniya' },
  { cn: '库克群岛', code: '682', en: 'Cook Islands', pinyin: 'kukequndao' },
  { cn: '拉脱维亚', code: '371', en: 'Latvia', pinyin: 'latuoweiya' },
  { cn: '莱索托', code: '266', en: 'Lesotho', pinyin: 'laisuotuo' },
  { cn: '老挝', code: '856', en: 'Laos', pinyin: 'laowo' },
  { cn: '黎巴嫩', code: '961', en: 'Lebanon', pinyin: 'libanen' },
  { cn: '立陶宛', code: '370', en: 'Lithuania', pinyin: 'litaowan' },
  { cn: '利比里亚', code: '231', en: 'Liberia', pinyin: 'libiliya' },
  { cn: '利比亚', code: '218', en: 'Libya', pinyin: 'libiya' },
  { cn: '列支敦士登', code: '423', en: 'Liechtenstein', pinyin: 'liezhidunshideng' },
  { cn: '留尼汪', code: '262', en: 'Réunion', pinyin: 'liuniwang' },
  { cn: '卢森堡', code: '352', en: 'Luxembourg', pinyin: 'lusenbao' },
  { cn: '卢旺达', code: '250', en: 'Rwanda', pinyin: 'luwangda' },
  { cn: '罗马尼亚', code: '40', en: 'Romania', pinyin: 'luomaniya' },
  { cn: '马达加斯加', code: '261', en: 'Madagascar', pinyin: 'madajiasijia' },
  { cn: '马德拉', code: '351', en: 'Madeira', pinyin: 'madela' },
  { cn: '马尔代夫', code: '960', en: 'Maldives', pinyin: 'maerdaifu' },
  { cn: '马耳他', code: '356', en: 'Malta', pinyin: 'maerta' },
  { cn: '马拉维', code: '265', en: 'Malawi', pinyin: 'malawei' },
  { cn: '马来西亚', code: '60', en: 'Malaysia', pinyin: 'malaixiya' },
  { cn: '马里', code: '223', en: 'Mali', pinyin: 'mali' },
  { cn: '马其顿', code: '389', en: 'Macedonia', pinyin: 'maqidun' },
  { cn: '马提尼克', code: '596', en: 'Martinique', pinyin: 'matinike' },
  { cn: '马约特', code: '262', en: 'Mayotte', pinyin: 'mayuete' },
  { cn: '毛里求斯', code: '230', en: 'Mauritius', pinyin: 'maoliqiusi' },
  { cn: '毛里塔尼亚', code: '222', en: 'Mauritania', pinyin: 'maolitaniya' },
  { cn: '美国', code: '1', en: 'United States', pinyin: 'meiguo' },
  { cn: '美属萨摩亚', code: '1684', en: 'American Samoa', pinyin: 'meishusamoya' },
  { cn: '美属维尔京群岛', code: '1340', en: 'U.S. Virgin Islands', pinyin: 'meishuweierjingqundao' },
  { cn: '蒙古', code: '976', en: 'Mongolia', pinyin: 'menggu' },
  { cn: '蒙特塞拉特', code: '1664', en: 'Montserrat', pinyin: 'mengtesailate' },
  { cn: '孟加拉国', code: '880', en: 'Bangladesh', pinyin: 'mengjialaguo' },
  { cn: '秘鲁', code: '51', en: 'Peru', pinyin: 'bilu' },
  { cn: '密克罗尼西亚', code: '691', en: 'Micronesia', pinyin: 'mikeluonixiya' },
  { cn: '缅甸', code: '95', en: 'Myanmar (Burma)', pinyin: 'miandian' },
  { cn: '摩尔多瓦', code: '373', en: 'Moldova', pinyin: 'moerduowa' },
  { cn: '摩洛哥', code: '212', en: 'Morocco', pinyin: 'moluoge' },
  { cn: '摩纳哥', code: '377', en: 'Monaco', pinyin: 'monage' },
  { cn: '莫桑比克', code: '258', en: 'Mozambique', pinyin: 'mosangbike' },
  { cn: '墨西哥', code: '52', en: 'Mexico', pinyin: 'moxige' },
  { cn: '纳米比亚', code: '264', en: 'Namibia', pinyin: 'namibiya' },
  { cn: '南非', code: '27', en: 'South Africa', pinyin: 'nanfei' },
  { cn: '南苏丹', code: '211', en: 'South Sudan', pinyin: 'nansudan' },
  { cn: '尼泊尔', code: '977', en: 'Nepal', pinyin: 'niboer' },
  { cn: '尼加拉瓜', code: '505', en: 'Nicaragua', pinyin: 'nijialagua' },
  { cn: '尼日尔', code: '227', en: 'Niger', pinyin: 'nirier' },
  { cn: '尼日利亚', code: '234', en: 'Nigeria', pinyin: 'niriliya' },
  { cn: '纽埃', code: '683', en: 'Niue', pinyin: 'niuai' },
  { cn: '挪威', code: '47', en: 'Norway', pinyin: 'nuowei' },
  { cn: '帕劳', code: '680', en: 'Palau', pinyin: 'palao' },
  { cn: '葡萄牙', code: '351', en: 'Portugal', pinyin: 'putaoya' },
  { cn: '日本', code: '81', en: 'Japan', pinyin: 'riben' },
  { cn: '瑞典', code: '46', en: 'Sweden', pinyin: 'ruidian' },
  { cn: '瑞士', code: '41', en: 'Switzerland', pinyin: 'ruishi' },
  { cn: '萨尔瓦多', code: '503', en: 'El Salvador', pinyin: 'saerwaduo' },
  { cn: '萨摩亚', code: '685', en: 'Samoa', pinyin: 'samoya' },
  { cn: '塞尔维亚', code: '381', en: 'Serbia', pinyin: 'saierweiya' },
  { cn: '塞拉利昂', code: '232', en: 'Sierra Leone', pinyin: 'sailaliang' },
  { cn: '塞内加尔', code: '221', en: 'Senegal', pinyin: 'saineijiaer' },
  { cn: '塞浦路斯', code: '357', en: 'Cyprus', pinyin: 'saipulusi' },
  { cn: '塞舌尔', code: '248', en: 'Seychelles', pinyin: 'saisheer' },
  { cn: '沙特阿拉伯', code: '966', en: 'Saudi Arabia', pinyin: 'shatealabo' },
  { cn: '圣巴泰勒米', code: '590', en: 'Saint Barthélemy', pinyin: 'shengbatailemi' },
  { cn: '圣赫勒拿', code: '290', en: 'Saint Helena', pinyin: 'shenghelena' },
  { cn: '圣基茨和尼维斯', code: '1869', en: 'Saint Kitts and Nevis', pinyin: 'shengjiciheniweisi' },
  { cn: '圣卢西亚', code: '1758', en: 'Saint Lucia', pinyin: 'shengluxiya' },
  { cn: '圣马力诺', code: '378', en: 'San Marino', pinyin: 'shengmalinuo' },
  { cn: '圣皮埃尔和密克隆', code: '508', en: 'Saint Pierre and Miquelon', pinyin: 'shengpiyaierhemikelong' },
  { cn: '圣文森特和格林纳丁斯', code: '1784', en: 'St. Vincent & Grenadines', pinyin: 'shengwensentehegelinnadingsi' },
  { cn: '斯里兰卡', code: '94', en: 'Sri Lanka', pinyin: 'sililanka' },
  { cn: '斯洛伐克', code: '421', en: 'Slovakia', pinyin: 'siluofake' },
  { cn: '斯洛文尼亚', code: '386', en: 'Slovenia', pinyin: 'siluowenniya' },
  { cn: '斯威士兰', code: '268', en: 'Swaziland', pinyin: 'siweishilan' },
  { cn: '苏丹', code: '249', en: 'Sudan', pinyin: 'sudan' },
  { cn: '苏里南', code: '597', en: 'Suriname', pinyin: 'sulinan' },
  { cn: '索马里', code: '252', en: 'Somalia', pinyin: 'suomali' },
  { cn: '所罗门群岛', code: '677', en: 'Solomon Islands', pinyin: 'suoluomenqundao' },
  { cn: '塔吉克斯坦', code: '992', en: 'Tajikistan', pinyin: 'tajikesitan' },
  { cn: '泰国', code: '66', en: 'Thailand', pinyin: 'taiguo' },
  { cn: '坦桑尼亚', code: '255', en: 'Tanzania', pinyin: 'tansangniya' },
  { cn: '汤加', code: '676', en: 'Tonga', pinyin: 'tangjia' },
  { cn: '特克斯和凯科斯群岛', code: '1649', en: 'Turks and Caicos Islands', pinyin: 'tekesihekaikesiqundao' },
  { cn: '特立尼达和多巴哥', code: '1868', en: 'Trinidad and Tobago', pinyin: 'telinidaheduobage' },
  { cn: '突尼斯', code: '216', en: 'Tunisia', pinyin: 'tunisi' },
  { cn: '图瓦卢', code: '688', en: 'Tuvalu', pinyin: 'tuwalu' },
  { cn: '土耳其', code: '90', en: 'Turkey', pinyin: 'tuerqi' },
  { cn: '土库曼斯坦', code: '993', en: 'Turkmenistan', pinyin: 'tukumansitan' },
  { cn: '托克劳', code: '690', en: 'Tokelau', pinyin: 'tuokelao' },
  { cn: '瓦利斯和富图纳', code: '681', en: 'Wallis and Futuna', pinyin: 'walisihefutuna' },
  { cn: '瓦努阿图', code: '678', en: 'Vanuatu', pinyin: 'wanuatu' },
  { cn: '危地马拉', code: '502', en: 'Guatemala', pinyin: 'weidimala' },
  { cn: '委内瑞拉', code: '58', en: 'Venezuela', pinyin: 'weineiruila' },
  { cn: '文莱', code: '673', en: 'Brunei', pinyin: 'wenlai' },
  { cn: '乌干达', code: '256', en: 'Uganda', pinyin: 'wuganda' },
  { cn: '乌克兰', code: '380', en: 'Ukraine', pinyin: 'wukelan' },
  { cn: '乌拉圭', code: '598', en: 'Uruguay', pinyin: 'wulagui' },
  { cn: '乌兹别克斯坦', code: '998', en: 'Uzbekistan', pinyin: 'wuzibiekesitan' },
  { cn: '西班牙', code: '34', en: 'Spain', pinyin: 'xibanya' },
  { cn: '希腊', code: '30', en: 'Greece', pinyin: 'xila' },
  { cn: '新加坡', code: '65', en: 'Singapore', pinyin: 'xinjiapo' },
  { cn: '新喀里多尼亚', code: '687', en: 'New Caledonia', pinyin: 'xinkaliduoniya' },
  { cn: '新西兰', code: '64', en: 'New Zealand', pinyin: 'xinxilan' },
  { cn: '匈牙利', code: '36', en: 'Hungary', pinyin: 'xiongyali' },
  { cn: '叙利亚', code: '963', en: 'Syria', pinyin: 'xuliya' },
  { cn: '牙买加', code: '1876', en: 'Jamaica', pinyin: 'yamaijia' },
  { cn: '亚美尼亚', code: '374', en: 'Armenia', pinyin: 'yameiniya' },
  { cn: '也门', code: '967', en: 'Yemen', pinyin: 'yemen' },
  { cn: '伊拉克', code: '964', en: 'Iraq', pinyin: 'yilake' },
  { cn: '伊朗', code: '98', en: 'Iran', pinyin: 'yilang' },
  { cn: '以色列', code: '972', en: 'Israel', pinyin: 'yiselie' },
  { cn: '意大利', code: '39', en: 'Italy', pinyin: 'yidali' },
  { cn: '印度', code: '91', en: 'India', pinyin: 'yindu' },
  { cn: '印度尼西亚', code: '62', en: 'Indonesia', pinyin: 'yindunixiya' },
  { cn: '英国', code: '44', en: 'United Kingdom', pinyin: 'yingguo' },
  { cn: '英属维尔京群岛', code: '1284', en: 'British Virgin Islands', pinyin: 'yingshuweierjingqundao' },
  { cn: '约旦', code: '962', en: 'Jordan', pinyin: 'yuedan' },
  { cn: '越南', code: '84', en: 'Vietnam', pinyin: 'yuenan' },
  { cn: '赞比亚', code: '260', en: 'Zambia', pinyin: 'zanbiya' },
  { cn: '乍得', code: '235', en: 'Chad', pinyin: 'zhade' },
  { cn: '直布罗陀', code: '350', en: 'Gibraltar', pinyin: 'zhibuluotuo' },
  { cn: '智利', code: '56', en: 'Chile', pinyin: 'zhili' },
  { cn: '中非共和国', code: '236', en: 'Central African Republic', pinyin: 'zhongfeigongheguo' },
  { cn: '中国', code: '86', en: 'China', pinyin: 'zhongguo' },
  { cn: '中国澳门', code: '853', en: 'Macau', pinyin: 'zhongguoaomen' },
  { cn: '中国台湾', code: '886', en: 'Taiwan', pinyin: 'zhongguotaiwan' },
  { cn: '中国香港', code: '852', en: 'Hong Kong', pinyin: 'zhongguoxianggang' }
]
